export default "__VITE_ASSET__BChlU53p__"